import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { BCLedgerTopClientRptRequestDto } from "../../../../../core/models/reports/bcLedgerTopClientRptRequestDto";
import { FormsModule } from "@angular/forms";
import { DatePickerModule } from "primeng/datepicker";
import { Employee } from "../../../../../core/models/profile/employee";
import { Select, SelectChangeEvent, SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-rpt-client-filter",
  templateUrl: "./rpt-client-filter.component.html",
  styleUrls: ["./rpt-client-filter.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    DatePickerModule,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class RptClientFilterComponent implements OnInit {
  @ViewChild("filter") filter!: Select;

  bcLedgerForm: BCLedgerTopClientRptRequestDto =
    {} as BCLedgerTopClientRptRequestDto;

  @Input() bcList!: Employee[];
  @Input() bcSelectedId = "";
  @Output() bcLedgerFormEvent =
    new EventEmitter<BCLedgerTopClientRptRequestDto>();

  fromDate = "";
  toDate = "";
  selectedDateRange!: string;
  disabledFromAndToDate = true;

  dateRange = [
    {
      id: 1,
      name: "",
    },
    {
      id: 2,
      name: "Last 12 Months",
    },
    {
      id: 3,
      name: "Current Calendar Year",
    },
    {
      id: 4,
      name: "Last Calendar Year",
    },
    {
      id: 5,
      name: "Current Fiscal Year",
    },
    {
      id: 6,
      name: "Custom",
    },
  ];

  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {
    this.initizeDate();
    this.setToAndFromDates();
  }

  initizeDate() {
    this.bcLedgerForm = {
      FromDate: this.datepipe.transform(this.fromDate, "MM/dd/yyyy") ?? "",
      ToDate: this.datepipe.transform(this.toDate, "MM/dd/yyyy") ?? "",
      BrandingConsultantID: this.bcSelectedId ?? "",
      DateRange: this.selectedDateRange,
    };
  }

  onFromDateSelection(event: Date) {
    const date = new Date(event);
    this.bcLedgerForm.FromDate =
      this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
  }

  onToDateSelection(event: Date) {
    const lDayOfMonth = new Date(event.getFullYear(), event.getMonth() + 1, 0);
    this.bcLedgerForm.ToDate =
      this.datepipe.transform(lDayOfMonth, "MM/dd/yyyy") ?? "";
  }

  onSubmit() {
    this.bcLedgerForm.BrandingConsultantID = this.bcSelectedId;
    this.bcLedgerForm.DateRange = this.selectedDateRange;
    this.bcLedgerFormEvent.emit(this.bcLedgerForm);
  }

  transformDateFormat(date: string | Date) {
    return this.datepipe.transform(date, "MM/yyyy");
  }

  patchValueInDate() {
    this.bcLedgerForm = {
      FromDate: this.transformStartDate(this.fromDate) ?? "",
      ToDate: this.transformEndDate(this.toDate) ?? "",
      BrandingConsultantID: this.bcSelectedId ?? "",
      DateRange: this.selectedDateRange,
    };
  }

  transformStartDate(dateString: string) {
    const [month, year] = dateString.split("/");
    return `${month}/01/${year}`;
  }

  transformEndDate(dateString: string): string {
    const [month, year] = dateString.split("/");
    const lastDay = new Date(Number(year), Number(month), 0).getDate();
    return `${month}/${lastDay}/${year}`;
  }

  filterDisabled() {
    if (
      this.bcSelectedId === "" ||
      this.fromDate === "" ||
      this.toDate === "" ||
      this.selectedDateRange === "" ||
      this.selectedDateRange === undefined
    ) {
      return true;
    }
    return false;
  }

  setToAndFromDates() {
    if (!this.fromDate) {
      this.fromDate = this.transformDateFormat(new Date()) ?? "";
    } else {
      this.fromDate = this.transformDateFormat(this.fromDate) ?? "";
    }
    if (!this.toDate) {
      this.toDate = this.transformDateFormat(new Date()) ?? "";
    } else {
      this.toDate = this.transformDateFormat(new Date()) ?? "";
    }
  }

  onDateRangeSelection(range: SelectChangeEvent) {
    if (this.filter?.overlayVisible) {
      if (range.value === "Last 12 Months") {
        this.disabledFromAndToDate = true;
        const curDate = new Date();
        const lastYearDate = new Date(
          curDate.getFullYear() - 1,
          curDate.getMonth(),
          1
        );
        this.fromDate = this.transformDateFormat(lastYearDate) ?? "";
        this.toDate =
          this.transformDateFormat(
            new Date(curDate.getFullYear(), curDate.getMonth() - 1, 1)
          ) ?? "";
        this.patchValueInDate();
      } else if (range.value === "Current Calendar Year") {
        this.disabledFromAndToDate = true;
        this.toDate = this.transformDateFormat(new Date()) ?? "";
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), 0, 1);
        this.fromDate = this.transformDateFormat(firstDay) ?? "";
        this.patchValueInDate();
      } else if (range.value === "Last Calendar Year") {
        this.disabledFromAndToDate = true;
        const curDate = new Date();
        const currentFormDate = new Date(curDate.getFullYear() - 1, 0, 1);
        this.fromDate = this.transformDateFormat(currentFormDate) ?? "";

        const currentToDate = new Date(curDate.getFullYear() - 1, 11, 1);
        this.toDate = this.transformDateFormat(currentToDate) ?? "";
        this.patchValueInDate();
      } else if (range.value === "Current Fiscal Year") {
        this.disabledFromAndToDate = true;
        const curDate = new Date();
        let currentYear = curDate.getFullYear();
        if (curDate.getMonth() < 3) {
          currentYear = curDate.getFullYear() - 1;
        }
        const date = new Date(`April 1 ${currentYear}`);
        this.fromDate = this.transformDateFormat(date) ?? "";
        this.toDate = this.transformDateFormat(new Date()) ?? "";
        this.patchValueInDate();
      } else if (range.value === "Custom") {
        this.disabledFromAndToDate = false;
        this.patchValueInDate();
      }
    }
  }
}
